const filterUnique = (val, i, arr) => arr.indexOf(val) === i;

module.exports = filterUnique;
